import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PublicHeader from './PublicHeader';
import Footer from './Footer';
import SeasonBoard from './leaderboard/SeasonBoard';
import './PublicMatches.css';
import usePageTitle from '../utils/usePageTitle';

// Public season leaderboard (/season/:id): the season board on finished matches only
// (GET /api/seasons/public/:id/board).
function PublicSeasonLeaderboard() {
  const { t } = useTranslation();
  const { id } = useParams();
  const [season, setSeason] = useState(null);
  usePageTitle(season ? `${season.name} - ${t('seo.leaderboard', 'Leaderboard')}` : null);

  return (
    <div className="pub-root">
      <PublicHeader />
      <div style={{ flex: 1, maxWidth: 1240, width: '100%', margin: '0 auto', padding: '1.5rem 1rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: '1.1rem' }}>
          <Link to="/" style={{ color: 'var(--text-muted)', textDecoration: 'none', fontSize: '0.8rem' }}>← {t('common.back', 'Back')}</Link>
          <span style={{ color: 'var(--border-default, rgba(255,255,255,0.09))' }}>|</span>
          <h1 style={{ margin: 0, fontSize: '1.15rem', fontWeight: 700, color: 'var(--text-primary)', letterSpacing: '-0.01em' }}>{season ? season.name : '…'}</h1>
          <span style={{
            background: 'rgba(59,130,246,0.08)', border: '1px solid rgba(59,130,246,0.2)',
            color: 'var(--accent-blue)', padding: '2px 8px', borderRadius: 'var(--radius-sm, 6px)', fontSize: '0.72rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em',
          }}>{t('leaderboard.title', 'Leaderboard')}</span>
        </div>
        <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border-subtle)', borderRadius: 'var(--radius-lg)', padding: '1.1rem 1.25rem' }}>
          <SeasonBoard seasonId={id} publicView onLoad={d => setSeason(d.season)} />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default PublicSeasonLeaderboard;
